
import { Icon, } from '@gluestack-ui/themed';
import React, {  FunctionComponent } from 'react';
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import { useStores } from '../../models';
import { PAYLOAD_TYPE } from '../../voolks/types';
import { onAction } from 'mobx-state-tree';
import { useDebouncedCallback } from 'use-debounce';
import { useNavigation } from '@react-navigation/native';
import { customApp } from '../../config';
import Spacer from '../base/Spacer';
import {
    View, Text, Linking, Image as ImageRN, Pressable, StyleSheet,
    Platform
} from 'react-native';

import { ColorsByName } from '../../../app/configGlueStack/gluestack-ui.config';

export interface IElementBaseProps {
    errors?: string[],
    element: any,
    rightButton?: any,
    leftButton?: any,
    forReview?: boolean,
    boxStyle?: any,
    parentId?: string,
    link?: string,
    hint?: string,
    recordIdx?: number,
    hideTitleBar?: boolean,
    borderBottomWidth?: number,
    setItemRef?: any,
    elementsTemplate?: any,
    changedMe?: any,
}

export const getIconHasError = (errors: string[], element: any) => {
    let hasError = errors.length > 0;
    if (!hasError)
        return <></>;

    if (element.validation?.alertOnly == true && errors.includes("Este campo es requerido") == false)
        return (<Icon as={Ionicons} name="warning-outline" size="lg" color="$warning500" />)
    else
        return (<Icon as={Ionicons} name="warning" size="lg" color="$danger500" />)
}

export const initPayloadValid = (element, payload, setPayload, getErrorElement) => {
    if (payload.valid == null || payload.inactiveGroup) {
        let errorElement = getErrorElement(element, payload.value);
        setPayload({ ...payload, valid: errorElement.valid, inactiveGroup: false });
    }
}

export const useInitializeElement = (props, withUpdPayloadElement = true,
    parseValueFromPopulate = ((value, element, itemStore) => value)) => {
    const element = props.element;
    const { itemsStore, statusStore, integrationsStore, authenticationStore } = useStores();
    const initialPayload = React.useMemo(() =>{
        const ret= itemsStore.getPayloadElement(props.element.id, props.parentId, props.recordIdx);
       // ret.value = ret.value ?? itemsStore.loadConstValues(props.element);
       /* if(ret.value==null  && props.element.templateData?.preset!=undefined)
            return {...ret, value:itemsStore.loadConstValues(props.element)}*/
        return ret;
    }
    ,[props.element.id, props.parentId, props.recordIdx]);

    const [payload, setPayload] = React.useState<PAYLOAD_TYPE>(initialPayload);

    const initErrorList = React.useMemo(() =>
        itemsStore.getErrorElement(props.element, payload?.value).errorList,
        [props.element, payload?.value]);

    const [errorList, setErrorList] = React.useState<string[]>(initErrorList)
    const [modalVisible, setModalVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const firstRun = React.useRef(true)
    const navigation = useNavigation();
    props.forReview = element.templateData.readOnly || payload.readOnly || props.forReview;
    const updDebounced = useDebouncedCallback(() => {
        try {
            itemsStore.updPayloadElement(element.id, payload, props.parentId, props.recordIdx, element.templateData?.closeRecord);
            if (element.templateData?.closeRecord) {
                const ItemsListScreenName = customApp.isPTW ? "PTWHome" : "ItemsList";
                // @ts-ignore
                navigation.navigate(ItemsListScreenName, navigation.getState().routes.find(k => k.name == ItemsListScreenName).params);
            }
        } catch (e) {
            console.log(element.id, element.name, e);
        }
    }, ["text", "number"].includes(element.type) ? 5 : 0);

    React.useEffect(() => {
        initPayloadValid(element, payload, setPayload, itemsStore.getErrorElement);
    }, [])
    if (withUpdPayloadElement)
        React.useEffect(() => {
            if (firstRun.current || element.type == "group")
                firstRun.current = false;
            else {
                updDebounced()
            }

        }, [payload]);

    React.useEffect(() => {
        let _disposerOnAction = onAction(statusStore, async call => {
            if (call.name == "reloadPayloadElementFromPopulate" && Object.values(call.args[1]).includes(element.id)) {
                const payload = itemsStore.getPayloadElement(element.id, props.parentId, props.recordIdx);
                let value = payload.value;
                value = await parseValueFromPopulate(value, element, itemsStore);
                if (element.type == "simplelist") {
                    value = JSON.parse(JSON.stringify(value));
                    function walk(nodes, record) {
                        nodes.forEach((f: any) => {
                            let nodeValid = itemsStore.getErrorElement(f, record[f.id]?.value);
                            if (record[f.id] == undefined)
                                record[f.id] = { value: record[f.id]?.value, valid: (f.isArchived || nodeValid?.valid), type: f.type, templateData: { useAsTitle: f.templateData?.useAsTitle } }
                            if (Array.isArray(f.nodes)) walk(f.nodes, record);
                        });
                    }
                    value.forEach(record => walk(element.nodes, record));
                }
                checkAndSetPayload(value, undefined, payload);
            }
        })
        return () => {
            _disposerOnAction();
        }
    }, []);

    const _checkAndSetPayload = (payloadValue, activeRecord = undefined, payloadToReload = {}) => {
        if (payload.readOnly)
            return null;
        let errorElement = itemsStore.getErrorElement(element, payloadValue);
        setPayload({ ...payload, ...payloadToReload, value: payloadValue, valid: errorElement.valid, activeRecord: (activeRecord || payload.activeRecord) });
        setErrorList(errorElement.errorList);
        return errorElement;
    }
    const checkAndSetPayload = React.useCallback(_checkAndSetPayload, [element, itemsStore, payload.readOnly]);

    return {
        itemsStore, statusStore, integrationsStore, authenticationStore,
        element,
        payload, setPayload, checkAndSetPayload,
        errorList, setErrorList,
        modalVisible, setModalVisible,
        loading, setLoading,
    }
}

export const initializeElement = useInitializeElement;




const _ElementBase: FunctionComponent<IElementBaseProps> = ({ ...props }) => {
    const { statusStore } = useStores();
    const { element, children, errors, forReview, hideTitleBar: forcedHide } = props;
    if (element.templateData == undefined)
        element.templateData = {};

    if(["6x26o7t3p","rro5wmf54"].includes(element.id)){
    element.templateData.direction="row";
    element.templateData.nameWeight= "bold"; //"normal";
    element.templateData.nameAlign = "center";
    element.templateData.nameSize = 20;
    }
    
    const templateData = element.templateData || {};
    const link: string = props.link || element.templateData?.href;
    const hint: string = props.hint || element.templateData?.hint;
    const hideTitleBar = forcedHide || templateData.hidden_label;
    templateData.nameAlign = templateData.nameAlign ?? "flex-start";
    
    const errorElements = React.useMemo(() => {
        if (!errors?.length) return null;
        const isWarning = element.validation?.alertOnly && !errors.includes("Este campo es requerido");
        return (<View style={styles.errorContainer}>{
            errors.map((err, i) => (
                <Text
                    key={`${element.id}-err-${i}`}
                    style={[styles.errorText, isWarning && styles.warningText]}
                >
                    {err}
                </Text>
            ))
        }</View>)
    }, [errors, element.validation, forReview]);

    if (templateData.hidden) {
        return <View style={styles.hiddenContainer}>{children}</View>;
    }
    if (element.type === "group" && !templateData.showTitle) {
        return (
            <View style={[styles.groupOnly, { backgroundColor: templateData.backgroundColor || "#fff" }]}>
                {children}
            </View>
        );
    }

    const isWide = statusStore.windowDimensions.width > 600;
    const containerStyle = [
        styles.baseContainer,
        { 
            backgroundColor: templateData.backgroundColor || "#fff",
            width:  "100%" 
        }, templateData.direction == "row" ? styles.rowContainer: styles.colContainer, 
        props.boxStyle
    ];

     const childrenContainer = [
        styles.childrenContainer,
        { 
            backgroundColor: templateData.backgroundColor || "#ffffffff",
            width:  "99%" 
        }, templateData.direction == "row" ? styles.rowContainer: styles.colContainer, 
        props.boxStyle
    ];

    const readOnly = element.templateData.readOnly || props.forReview;

    return (
        <View style={containerStyle}>
            {!hideTitleBar && (
                <View style={[styles.headerRow,templateData.direction == "row" ?  styles.rowheaderRow :styles.colheaderRow]}>
                    <View style={styles.sideButtons}>{props.leftButton}</View>
                    
                    <View style={[styles.titleContainer,{justifyContent: templateData.nameAlign}]}>
                        <Text 
                            allowFontScaling={false} textBreakStrategy="simple" 
                            style={[styles.labelText, { color: templateData.textColor || "#000", fontWeight: templateData.nameWeight=="normal"? "normal":"bold", fontSize: templateData.nameSize  }]}
                        >
                            {element.name ?? element.label}
                        </Text>
                        
                        {link && (
                            <Pressable onPress={() => Linking.openURL(link)} hitSlop={10}>
                                <Icon as={MaterialIcons} name="launch" size="md" color="$closed400" style={styles.iconMargin} />
                            </Pressable>
                        )}
                        
                        {hint && (
                            <Pressable 
                                hitSlop={10}
                                onPress={(event: any) => statusStore.setHintMessage(element.name ?? element.label, hint, event.nativeEvent.pageX, event.nativeEvent.pageY)}
                            >
                                <Icon as={Ionicons} name="information-circle-outline" size="md" color={templateData.textColor || "#000"} style={styles.iconMargin} />
                            </Pressable>
                        )}
                    </View>

                    <View style={styles.sideButtons}>{readOnly ? null: props.rightButton}</View>
                </View>
            )}
            <View style={childrenContainer}>
                {children}
            </View>

            {link && hideTitleBar && (
                <View style={[styles.linkOnlyRow,styles.childrenContainer]}>
                    <Spacer />
                    <Pressable onPress={() => Linking.openURL(link)}>
                        <Icon as={MaterialIcons} name="launch" color="$closed400" />
                    </Pressable>
                </View>
            )}

            {errorElements}
        </View>
    );
};

export const ElementBase = React.memo(_ElementBase, (prevProps, nextProps) => {
    // Solo re-renderizar si el elemento o los errores cambian
    console.log("ElementBase ret",prevProps.element.name,prevProps.element.type,nextProps.forReview
        , prevProps.element.id === nextProps.element.id &&
        prevProps.errors == nextProps.errors &&
        prevProps.forReview == nextProps.forReview &&
        prevProps.changedMe === nextProps.changedMe &&
        prevProps.rightButton  === nextProps.rightButton
        
    )
    return (
        prevProps.element.id === nextProps.element.id &&
        prevProps.errors == nextProps.errors &&
        prevProps.forReview == nextProps.forReview &&
        prevProps.changedMe === nextProps.changedMe &&
        prevProps.rightButton  === nextProps.rightButton
    );
});

const styles = StyleSheet.create({
    baseContainer: {
        marginVertical: 2,
        marginHorizontal: 0,
        paddingTop: 10,
        paddingBottom: 5,
        minHeight: 69,
        flexWrap: 'wrap',
    },
    colContainer: {
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    rowContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    childrenContainer:{
        marginBottom:'auto',marginTop:'auto',flex:1,
    },
    hiddenContainer: {
        height: 1,
        opacity: 0,
        overflow: 'hidden',
    },
    groupOnly: {
        width: '100%',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    headerRow: { 
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 4,
    },
    colheaderRow: { 
       maxWidth:"100%"
    },
    rowheaderRow: { 
       maxWidth:"50%"
    },
    titleContainer: {
        flexShrink: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 4,flex:1, flexWrap:"wrap"
    },
    labelText: {
        fontWeight: 'bold',
    },
    sideButtons: {
        maxWidth: 120,
        flexDirection: "row-reverse",
    },
    iconMargin: {
        marginLeft: 8,
    },
    linkOnlyRow: {
        flexDirection: 'row',
    },
    errorContainer: {
        borderTopWidth: 1,
        borderColor: ColorsByName.danger500, // Equivalente a $danger500
        marginTop: 5,
        paddingLeft: 10,width:"100%", 
        paddingVertical:8,

    },
    errorText: {
        fontWeight: 'bold',
        fontSize: 12,
        color: ColorsByName.danger500,
    },
    warningText: {
        color: ColorsByName.warning500, // Equivalente a $warning500
    }
});